import { useTabsComponents } from '@/next/utils/useTabsComponents';
import { cn } from '@skand/ui';
import { useState } from 'react';
import { Viewer2DMenu } from './Viewer2DMenu';
import { Viewer3DMenu } from './Viewer3DMenu';

export const SettingsMenu = () => {
  const [currentTab, setCurrentTab] = useState('3d');
  const { Tabs, TabsList, TabsTrigger, TabsContent } = useTabsComponents();

  return (
    <div
      className={cn(
        'w-full',
        'flex',
        'flex-col',
        'bg-neutral-100',
        'p-12px',
        'rounded-1',
        'bg-neutral-100',
        'z-1',
        'max-h-[calc(100dvh-120px)] max-w-100dvw overflow-auto',
        'rounded-1 b-1 b-neutral-400 b-solid shadow-general',
      )}
    >
      <Tabs onValueChange={setCurrentTab} value={currentTab}>
        <TabsList>
          <TabsTrigger value="3d">3D Viewer</TabsTrigger>
          <TabsTrigger value="2d">Images</TabsTrigger>
        </TabsList>

        <TabsContent value="3d">
          <Viewer3DMenu />
        </TabsContent>

        <TabsContent value="2d">
          <Viewer2DMenu />
        </TabsContent>
      </Tabs>
    </div>
  );
};
